import Patient from './Patient';
import './Main.css';
import Col from './stateless/Col';
import Row from './stateless/Row';
import Card from './stateless/Card';

const Main = ({ showPatient }) => {
  return (
    <div className="container">
      <Row classes="my-5 h-100">
        <Col>
          <Card
            title="Over 37M Americans suffer from migraines"
            image="/Story_1.png"
            tooltip="and struggle with management of pain, medications, and treatments"
          ></Card>
        </Col>
        <Col>
          <Card
            title="Doctors give HADI to their patients"
            image="/Story_2.jpg"
            tooltip="to capture patient experience data in real time"
          ></Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card
            title="HADI captures meaningful data"
            image="/Story_3.png"
            tooltip="including daily pain levels, medications, and treatments"
          ></Card>
        </Col>
        <Col>
          <Card
            title="Physicians using HADI make better treatment decisions"
            image="/Story_4.png"
            tooltip="yielding the best outcomes and higher patient satisfaction"
          ></Card>
        </Col>
      </Row>
      {showPatient && <Patient />}
    </div>
  );
};

export default Main;
